import React, { useState, useEffect } from 'react';
import { Box, MenuItem, TextField, Button, Typography, Chip, Stack } from '@mui/material';
import LinkIcon from '@mui/icons-material/Link';

// IMPORTS CORREGIDOS: Funciones individuales
import { getAllAssets } from '../../../controllers/company/AssetsController'; 
import { 
    getResourcesByProduct, 
    assignResourceToProduct, 
    removeResourceFromProduct 
} from '../../../controllers/company/products/ProductResourceController';

import QUDProgress from '../../../components/progress';
import ResponseComponent from '../../../components/responseComponent';

export default function ResourceLinker({ productId }) {
  const [myAssets, setMyAssets] = useState([]); 
  const [assignedResources, setAssignedResources] = useState([]); 
  const [selectedAssetId, setSelectedAssetId] = useState('');
  
  const [isLoading, setIsLoading] = useState(false);
  const [responseState, setResponseState] = useState({ show: false, success: false, title: '', message: '' });

  useEffect(() => {
    if(productId) {
        loadData();
    }
  }, [productId]);

  const loadData = async () => {
    try {
        const [assetsRes, assignedRes] = await Promise.all([
            getAllAssets(), // Llamada directa
            getResourcesByProduct(productId) // Llamada directa
        ]);

        if(assetsRes.success) setMyAssets(assetsRes.data || []);
        if(assignedRes.success) setAssignedResources(assignedRes.data || []);

    } catch (e) {
        console.error(e);
    }
  };

  const handleAssign = async () => {
    if (!selectedAssetId) return;
    
    setIsLoading(true);
    // Llamada directa
    const res = await assignResourceToProduct(productId, selectedAssetId, 'asset');
    setIsLoading(false);

    if (res.success) {
        setSelectedAssetId('');
        loadData(); 
    } else {
        setResponseState({
            show: true, success: false, title: 'Error',
            message: res.message || 'No se pudo asignar el recurso.'
        });
    }
  };

  const handleRemove = async (assignmentId) => {
    if(!window.confirm("¿Desvincular este recurso del producto?")) return;
    
    setIsLoading(true);
    // Llamada directa
    const res = await removeResourceFromProduct(assignmentId);
    setIsLoading(false);

    if(res.success) {
        loadData();
    } else {
        setResponseState({
            show: true, success: false, title: 'Error',
            message: res.message || 'Error al desvincular.'
        });
    }
  };

  return (
    <Box sx={{ mt: 4, p: 3, border: '1px solid #e0e0e0', borderRadius: 2, bgcolor: '#fafafa' }}>
      <QUDProgress open={isLoading} />
      <ResponseComponent
        show={responseState.show}
        success={responseState.success}
        title={responseState.title}
        message={responseState.message}
        actionText="Ok"
        onClick={() => setResponseState({ ...responseState, show: false })}
      />

      <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
        <LinkIcon sx={{verticalAlign: 'middle', mr: 1}}/>
        Recursos Asignados (Dónde se realiza el servicio)
      </Typography>
      
      <Stack direction="row" spacing={1} sx={{ my: 2, flexWrap: 'wrap', gap: 1 }}>
        {assignedResources.map((res) => (
          <Chip 
            key={res.id} 
            label={res.asset ? `${res.asset.name} (Cap: ${res.asset.capacity})` : 'Recurso'} 
            onDelete={() => handleRemove(res.id)} 
            color="primary"
            variant="outlined"
          />
        ))}
        {assignedResources.length === 0 && (
            <Typography variant="body2" color="textSecondary">No hay recursos asignados aún.</Typography>
        )}
      </Stack>

      <Box sx={{ display: 'flex', gap: 2, mt: 2, alignItems: 'center' }}>
        <TextField
          select
          label="Seleccionar Activo Disponible"
          value={selectedAssetId}
          onChange={(e) => setSelectedAssetId(e.target.value)}
          fullWidth
          size="small"
          sx={{maxWidth: 400}}
        >
          {myAssets.map((asset) => (
            <MenuItem key={asset.id} value={asset.id}>
              {asset.name} (Cap: {asset.capacity})
            </MenuItem>
          ))}
        </TextField>
        <Button variant="contained" onClick={handleAssign} disabled={!selectedAssetId}>
          Asignar
        </Button>
      </Box>
    </Box>
  );
}